import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

/** The homepage status a list was opened with; clearing it shows the whole list again. */
export function StageFilterChip({ label, onClear }: { label: string; onClear: () => void }) {
  return (
    <Button
      variant="secondary"
      className="h-9 w-full justify-between gap-2 md:w-auto"
      onClick={onClear}
      aria-label={`Clear ${label} filter`}
    >
      {label}
      <X className="h-4 w-4" />
    </Button>
  )
}
